import React from 'react'
import PropTypes from 'prop-types';

import RenderRichText from 'utils/richText/renderRichText';

const TableBody = ({data, preview}) => {
  return (
    <tbody>
      {data.items.map((el, index) => (
        <tr key={index.toString()}>
          <td>
            <RenderRichText richTextArray={preview ? el.left_column_row_data : el.left_column_row_data.raw} />
          </td>
          <td>
            <RenderRichText richTextArray={preview ? el.right_column_row_data : el.right_column_row_data.raw} />
          </td>
        </tr>
      ))}
    </tbody>
  )
}

TableBody.propTypes = {
  data: PropTypes.object,
  preview: PropTypes.bool
}

export default TableBody
